import { FilialProvider } from '@/contexts/FilialContext';
import { PlacaSearchProvider } from '@/contexts/PlacaSearchContext';
import { PlacaSearchModal } from '@/components/placa/PlacaSearchModal';
import { AppShell } from './AppShell';

export function AuthenticatedLayout() {
  return (
    <FilialProvider>
      <PlacaSearchProvider>
        <PlacaSearchModal />
        <AppShell />
      </PlacaSearchProvider>
    </FilialProvider>
  );
}
